import React, {useEffect, useState} from "react";
import {connectHits} from "react-instantsearch-dom";
import Checkbox from "../Checkbox";
import {orderBy} from "lodash";
import PartnerMessagePanel from "./PartnerMessagePanel";
import Modal from "react-modal";

const currentItemRefinement = new Set();

function uniqBy(items, property) {
    const seen = {};

    return items.filter(item => {
        const val = item[property];

        if (seen[val]) {
            return false;
        } else {
            seen[val] = true;
            return true;
        }
    });
}

const modalSizeStyles = {
    content: {
        position: 'absolute',
        inset: '10%',
        background: 'none',
        border: 'none',
        overflow: 'initial',
        outline: 'none',
        padding: '0px',
        marginTop: '15px',
    },
};

const modalMessageSizeStyles = {
    content: {
        position: 'absolute',
        inset: '20%',
        border: '1px solid rgb(204, 204, 204)',
        background: 'rgb(255, 255, 255)',
        overflow: 'initial',
        borderRadius: '4px',
        outline: 'none',
        padding: '0px',
        marginTop: '15px',
    },
};

const PartnerResultOptions = connectHits(({hits, messageIsOpen, onMessageShow, onMessageClose, onMessageOpen, messageCancel}) => {

    console.log('onMessageShow', onMessageShow);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPartners, setSelectedPartners] = useState([]);
    const [notSelectedPartners, setNotSelectedPartners] = useState([]);
    const [isAbleToSend, setIsAbleToSend] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);

    const p_array = ['Individuals', 'Companies', 'Manufacturers Suppliers'];
    const c_array = ['Community Members'];


    useEffect(() => {
        if (messageIsOpen === false) {
            console.log('MATmessageIsOpen', messageIsOpen);
            setIsOpen(false);
        }
        if (messageCancel === true) {
            console.log('MATmessageCancel', messageCancel);
            currentItemRefinement.clear();

        }
        if (hits.length > 0) {
            setIsLoading(false);
        } else {
            let timer = setTimeout(() => setIsLoading(false), 3000);
            return () => {
                clearTimeout(timer);
            };
        }
    });

    let openModal = () => {
        onMessageOpen();
        setIsOpen(true);
    }

    let closeModal = () => {
        setIsOpen(false);
        onMessageClose();
    }

    if (onMessageShow === true) {
        if (!modalIsOpen) {
            setIsOpen(true);
        }
    }


    let sortedItems = orderBy(hits, ['name'], ['asc']);
    sortedItems.map(s => {
        s.isToggled = false;
        return s;
    });

    const toggle = item => {  // update `currentItemRefinement` on toggle
        console.log('MATtoggle', item);
    };

    const combinedItems = orderBy(hits, ['name'], ['asc'])
        .slice(0, 50)
        .map(item => {
            // Here we re-calculate `isRefined` and `value` for each item
            // based on `currentItemRefinement` which we cached at `toggle`.
            //const isRefined = currentItemRefinement.has(item.label);
            const isToggled = currentItemRefinement.has(item.name);

            //remove item from currentItemRefinement if !isRefined
            //console.log('MAcurrentItemRefinementPRE', currentItemRefinement);
            //console.log('MACuR', isRefined);
            if (!isToggled) {
                //console.log('MACuRremove', item.label);
                //currentItemRefinement.delete(item.label);
            }
            //console.log('MAcurrentItemRefinementPOST', currentItemRefinement);

            const value =
                isToggled === false
                    ? [...currentItemRefinement, item.name]
                    : [...currentItemRefinement].filter(name => name !== item.name);
            const newItem = item;
            newItem.isToggled = isToggled;
            newItem.value = value;
            //console.log('MATcombinedItems', item);
            //console.log('MATcombinedItemsNEW', newItem);
            return {
                ...item,
                isToggled,
                value,
            };
        });

    const togglePartner = item => {
        if (item.isToggled) {
            currentItemRefinement.delete(item.name);
        } else {
            currentItemRefinement.add(item.name)
        }
        setNotSelectedPartners((prevList) => {
            if (prevList.includes(item.name)) {
                // Remove the word if it exists
                return prevList.filter((partner) => partner !== item.name);
            } else {
                // Add the word if it doesn't exist
                return [...prevList, item.name];
            }
        });
        item.isToggled = true;
        combinedItems.map(item => {
            item.isToggled = currentItemRefinement.has(item.name);
        })
        console.log('currentPartnersUpdate', selectedPartners);
        console.log('combinedItems', combinedItems);
        console.log('setNotSelectedPartners', notSelectedPartners);
    }

    const isPartnerToggled = item => {
        let currentPartners = selectedPartners;
        return !currentItemRefinement.has(item.name);
    }

    const canSendMessage = () => {
        let ableTo = combinedItems.filter((partner) => partner.isToggled !== true);
        return ableTo.length;
    }

    const sendMessage = () => {
        window.location.href = '/building-material-contact';
    }


    return (
        <React.Fragment>
            <div className="section__recently-joined">
                {modalIsOpen ? (
                    <div className="form-default">
                        <div className="panel">
                            <div className="panel__inner">
                                <div className="panel__head">
                                    <h5 className="panel__title">Contact Manufacturers and Suppliers</h5>
                                </div>

                                <div className="panel__body">
                                    <PartnerMessagePanel
                                        partners={combinedItems}
                                        onRemovePartner={(hit) => togglePartner(hit)}
                                        onMessageCancel={() => closeModal()}
                                        onMessageSend={() => sendMessage()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <React.Fragment>
                        {canSendMessage() > 0 && (
                            <button className="form__btn-filters form__btn-filters-action" onClick={openModal}>
                                {canSendMessage() === 1 && (
                                    <span>Click here to contact {canSendMessage()} Manufacturer & Supplier</span>
                                )}
                                {canSendMessage() > 1 && (
                                    <span>Click here to contact {canSendMessage()} Manufacturers & Suppliers</span>
                                )}
                            </button>
                        )}


                        <div className="widgets-recently-joined">
                            <div className="widgets__head">
                                <h3>Contact Manufacturers & Suppliers</h3>
                            </div>

                            <div className="widgets__body">
                                <div className="widgets__items">
                                    {combinedItems.map((hit, index) => (
                                        <div
                                            key={hit.label + "-" + index}
                                            className={`widgets__item--3 widgets__item--1of3 ${hit.isToggled ? 'widgets__item--3-hidden' : ''}`}
                                            onClick={() => togglePartner(hit)}
                                        >
                                            <div className="widget-recently-joined">
                                                <div className="widget__image">
                                                    <img src={hit.directory_image} alt=""/>
                                                </div>

                                                <div className="widget__content">
                                                    <h3>{hit.isToggled}{hit.name}</h3>
                                                </div>
                                            </div>
                                            <div style={{
                                                position: 'relative',
                                                left: '90%',
                                                bottom: '20%',
                                                width: '25px'
                                            }}>
                                                <Checkbox
                                                    disabled={false}
                                                    checked={isPartnerToggled(hit)}
                                                    onChange={() => toggle(hit)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    );


});

//const PartnerResultOptions = connectHits(Hits);
export default PartnerResultOptions;
